define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        RangeInput   = require("services/rangeInput/RangeInput"),
        template     = require("ui/experience/widgets/OpacityPropertiesView.tpl");

    return ImprovedView.extend({

        template: template,

        templateHelpers: function() {
            return {
                showName: !this.options.hideName
            };
        },

        regions: {
            opacityRangeRegion: ".opacity-range-region"
        },

        onRender: function() {
            this.opacityRangeRegion.show(new RangeInput({
                model: this.model,
                modelAttribute: "opacity",
                step: 10,
                minVal: 0,
                maxVal: 100,
                staticVal: 100,
                unit: "%",
                // Javascript polutes the calculation, hence the parseInt
                onGetConverter: function(x) { return parseInt(x * 100, 10); },
                onSetConverter: function(x) { return x / 100; }
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/OpacityPropertiesView.js